import { basename } from "path";
import Vue, { toRaw, defineComponent, onMounted, onUnmounted } from "vue";
import { t, n, a as normalizeComponent } from "./chunks/_plugin-vue2_normalizer-BNL0n0sv.mjs";
import { h, f, g, d, e, c, T, b, l, k, s, i, m, j } from "./chunks/_plugin-vue2_normalizer-BNL0n0sv.mjs";
import NcDialog from "@nextcloud/vue/dist/Components/NcDialog.js";
import NcNoteCard from "@nextcloud/vue/dist/Components/NcNoteCard.js";
const spawnDialog = (dialog, props, onClose = () => {
}) => {
  const el = document.createElement("div");
  const container = document.querySelector(props == null ? void 0 : props.container) || document.body;
  container.appendChild(el);
  const vue = new Vue({
    el,
    name: "VueDialogHelper",
    render: (h2) => h2(dialog, {
      props,
      on: {
        close: (...rest) => {
          onClose(...rest.map((v) => toRaw(v)));
          vue.$destroy();
        }
      }
    })
  });
  return vue;
};
const IconMove = '<svg xmlns="http://www.w3.org/2000/svg" id="mdi-folder-move" viewBox="0 0 24 24"><path d="M14,18V15H10V11H14V8L19,13M20,6H12L10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6Z" /></svg>';
const IconCopy = '<svg xmlns="http://www.w3.org/2000/svg" id="mdi-folder-multiple" viewBox="0 0 24 24"><path d="M22,4H14L12,2H6A2,2 0 0,0 4,4V16A2,2 0 0,0 6,18H22A2,2 0 0,0 24,16V6A2,2 0 0,0 22,4M2,6H0V11H0V20A2,2 0 0,0 2,22H20V20H2V6Z" /></svg>';
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var FilePickerType = /* @__PURE__ */ ((FilePickerType2) => {
  FilePickerType2[FilePickerType2["Choose"] = 1] = "Choose";
  FilePickerType2[FilePickerType2["Move"] = 2] = "Move";
  FilePickerType2[FilePickerType2["Copy"] = 3] = "Copy";
  FilePickerType2[FilePickerType2["CopyMove"] = 4] = "CopyMove";
  FilePickerType2[FilePickerType2["Custom"] = 5] = "Custom";
  return FilePickerType2;
})(FilePickerType || {});
class FilePickerClosed extends Error {
}
class FilePicker {
  constructor(title, multiSelect, mimeTypeFilter, directoriesAllowed, buttons, path, filter, container, disabledNavigation = false) {
    __publicField(this, "title");
    __publicField(this, "multiSelect");
    __publicField(this, "mimeTypeFilter");
    __publicField(this, "directoriesAllowed");
    __publicField(this, "buttons");
    __publicField(this, "path");
    __publicField(this, "filter");
    __publicField(this, "container");
    __publicField(this, "disabledNavigation");
    this.title = title;
    this.multiSelect = multiSelect;
    this.mimeTypeFilter = mimeTypeFilter;
    this.directoriesAllowed = directoriesAllowed;
    this.path = path;
    this.filter = filter;
    this.buttons = buttons;
    this.container = container;
    this.disabledNavigation = disabledNavigation;
  }
  /**
   * Pick files using the FilePicker
   *
   * @return Promise with array of picked files or rejected promise on close without picking
   */
  async pick() {
    const { FilePickerVue } = await import("./chunks/index-D5FJasts.mjs");
    return new Promise((resolve, reject) => {
      spawnDialog(FilePickerVue, {
        allowPickDirectory: this.directoriesAllowed,
        buttons: this.buttons,
        container: this.container,
        name: this.title,
        path: this.path,
        mimetypeFilter: this.mimeTypeFilter,
        multiselect: this.multiSelect,
        filterFn: this.filter,
        disabledNavigation: this.disabledNavigation
      }, (...rest) => {
        var _a;
        const [nodes] = rest;
        if (!Array.isArray(nodes) || nodes.length === 0) {
          reject(new FilePickerClosed("FilePicker: No nodes selected"));
        } else {
          if (this.multiSelect) {
            resolve(nodes.map((node) => node.path));
          } else {
            resolve(((_a = nodes[0]) == null ? void 0 : _a.path) || "/");
          }
        }
      });
    });
  }
}
class FilePickerBuilder {
  /**
   * Construct a new FilePicker
   *
   * @param title Title of the FilePicker
   */
  constructor(title) {
    __publicField(this, "title");
    __publicField(this, "multiSelect", false);
    __publicField(this, "mimeTypeFilter", []);
    __publicField(this, "directoriesAllowed", false);
    __publicField(this, "path");
    __publicField(this, "filter");
    __publicField(this, "buttons", []);
    __publicField(this, "container");
    __publicField(this, "disabledNavigation", false);
    this.title = title;
  }
  /**
   * Set the container where the FilePicker will be mounted
   * By default 'body' is used
   *
   * @param container The dialog container
   */
  setContainer(container) {
    this.container = container;
    return this;
  }
  /**
   * Enable or disable picking multiple files
   *
   * @param ms True to enable picking multiple files, false otherwise
   */
  setMultiSelect(ms) {
    this.multiSelect = ms;
    return this;
  }
  /**
   * Add allowed MIME type
   *
   * @param filter MIME type to allow
   */
  addMimeTypeFilter(filter) {
    this.mimeTypeFilter.push(filter);
    return this;
  }
  /**
   * Set allowed MIME types
   *
   * @param filter Array of allowed MIME types
   */
  setMimeTypeFilter(filter) {
    this.mimeTypeFilter = filter;
    return this;
  }
  /**
   * Add a button to the FilePicker
   * Note: This overrides any previous `setButtonFactory` call
   *
   * @param button The button
   */
  addButton(button) {
    if (typeof this.buttons === "function") {
      console.warn("FilePicker buttons were set to factory, now overwritten with button object.");
      this.buttons = [];
    }
    this.buttons.push(button);
    return this;
  }
  /**
   * Set the button factory which is used to generate buttons from current view, path and selected nodes
   * Note: This overrides any previous `addButton` call
   *
   * @param factory The button factory
   */
  setButtonFactory(factory) {
    this.buttons = factory;
    return this;
  }
  /**
   * Set FilePicker type based on legacy file picker types
   * @param type The legacy filepicker type to emulate
   * @deprecated Use `addButton` or `setButtonFactory` instead as with setType you do not know which button was pressed
   */
  setType(type) {
    this.buttons = (nodes, path) => {
      var _a, _b, _c;
      const buttons = [];
      const node = ((_b = (_a = nodes == null ? void 0 : nodes[0]) == null ? void 0 : _a.attributes) == null ? void 0 : _b.displayName) || ((_c = nodes == null ? void 0 : nodes[0]) == null ? void 0 : _c.basename);
      const target = node || basename(path);
      if (type === 1) {
        let label = t("Choose");
        if (nodes.length === 1) {
          label = t("Choose {file}", { file: node });
        } else if (this.multiSelect) {
          label = n("Choose %n file", "Choose %n files", nodes.length);
        }
        buttons.push({
          callback: () => {
          },
          type: "primary",
          label
        });
      }
      if (type === 4 || type === 3) {
        buttons.push({
          callback: () => {
          },
          label: target ? t("Copy to {target}", { target }) : t("Copy"),
          type: "primary",
          icon: IconCopy
        });
      }
      if (type === 2 || type === 4) {
        buttons.push({
          callback: () => {
          },
          label: target ? t("Move to {target}", { target }) : t("Move"),
          type: type === 2 ? "primary" : "secondary",
          icon: IconMove
        });
      }
      return buttons;
    };
    return this;
  }
  /**
   * Allow to pick directories besides files
   *
   * @param allow True to allow picking directories
   */
  allowDirectories(allow = true) {
    this.directoriesAllowed = allow;
    return this;
  }
  /**
   * Set starting path of the FilePicker
   *
   * @param path Path to start from picking
   */
  startAt(path) {
    this.path = path;
    return this;
  }
  /**
   * Add filter function to filter file list of FilePicker
   *
   * @param filter Filter function to apply
   */
  setFilter(filter) {
    this.filter = filter;
    return this;
  }
  /**
   * Allow to pick directories besides files
   *
   * @param allow True to allow picking directories
   */
  disableNavigation() {
    this.disabledNavigation = true;
    return this;
  }
  /**
   * Construct the configured FilePicker
   */
  build() {
    return new FilePicker(
      this.title,
      this.multiSelect,
      this.mimeTypeFilter,
      this.directoriesAllowed,
      this.buttons,
      this.path,
      this.filter,
      this.container,
      this.disabledNavigation
    );
  }
}
function getFilePickerBuilder(title) {
  return new FilePickerBuilder(title);
}
var DialogSeverity = /* @__PURE__ */ ((DialogSeverity2) => {
  DialogSeverity2["Info"] = "info";
  DialogSeverity2["Warning"] = "warning";
  DialogSeverity2["Error"] = "error";
  return DialogSeverity2;
})(DialogSeverity || {});
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "GenericDialog",
  props: {
    name: null,
    text: null,
    html: null,
    buttons: null,
    severity: null
  },
  setup(__props) {
    const props = __props;
    const handleUnload = () => "".concat(props.name, ": ").concat(props.text);
    onMounted(() => window.addEventListener("unload", handleUnload));
    onUnmounted(() => window.removeEventListener("unload", handleUnload));
    return { __sfc: true, props, handleUnload, NcDialog, NcNoteCard };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.NcDialog, { attrs: { "dialog-classes": "nc-generic-dialog", "buttons": _vm.buttons, "name": _vm.name, "message": _vm.text }, on: { "update:open": function($event) {
    return _vm.$emit("close");
  } } }, [_vm.severity ? _c(_setup.NcNoteCard, { attrs: { "type": _vm.severity } }, [_c("p", { domProps: { "textContent": _vm._s(_vm.text) } })]) : _vm._e(), _vm.html ? _c("div", { domProps: { "innerHTML": _vm._s(_vm.html) } }) : _vm._e()], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const GenericDialog = __component__.exports;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), member.set(obj, value), value);
var _name, _text, _buttons, _severity, _dialog, _html, _severity2, _text2, _name2, _buttons2;
class Dialog {
  constructor(name, text, buttons = [], severity) {
    __privateAdd(this, _name);
    __privateAdd(this, _text);
    __privateAdd(this, _buttons);
    __privateAdd(this, _severity);
    __privateAdd(this, _dialog);
    __privateAdd(this, _html);
    __privateSet(this, _name, name);
    __privateSet(this, _text, text);
    __privateSet(this, _buttons, buttons);
    __privateSet(this, _severity, severity);
    __privateSet(this, _dialog, void 0);
    __privateSet(this, _html, void 0);
  }
  /**
   * @deprecated DO NOT USE! It will be removed in the near future!
   * @param html HTML content
   */
  setHTML(html) {
    __privateSet(this, _html, html);
    return this;
  }
  /**
   * Spawn and show the dialog - if already open the previous instance will be destroyed
   * @return Promise that resolves when the dialog is answered successfully and rejects on close
   */
  show() {
    if (__privateGet(this, _dialog)) {
      __privateGet(this, _dialog).$destroy();
    }
    return new Promise((resolve) => {
      __privateSet(this, _dialog, spawnDialog(
        GenericDialog,
        {
          buttons: __privateGet(this, _buttons),
          name: __privateGet(this, _name),
          text: __privateGet(this, _text),
          severity: __privateGet(this, _severity),
          html: __privateGet(this, _html)
        },
        resolve
      ));
    });
  }
  /**
   * Hide and destroy the current dialog instance
   */
  hide() {
    var _a;
    (_a = __privateGet(this, _dialog)) == null ? void 0 : _a.$destroy();
  }
}
_name = /* @__PURE__ */ new WeakMap();
_text = /* @__PURE__ */ new WeakMap();
_buttons = /* @__PURE__ */ new WeakMap();
_severity = /* @__PURE__ */ new WeakMap();
_dialog = /* @__PURE__ */ new WeakMap();
_html = /* @__PURE__ */ new WeakMap();
class DialogBuilder {
  constructor(name) {
    __privateAdd(this, _severity2);
    __privateAdd(this, _text2);
    __privateAdd(this, _name2);
    __privateAdd(this, _buttons2);
    __privateSet(this, _severity2, void 0);
    __privateSet(this, _text2, "");
    __privateSet(this, _name2, name != null ? name : "");
    __privateSet(this, _buttons2, []);
  }
  /**
   * Set dialog name
   * @param name The name or headline of the dialog
   */
  setName(name) {
    __privateSet(this, _name2, name);
    return this;
  }
  /**
   * Set the dialog text
   * @param text Main text of the dialog
   */
  setText(text) {
    __privateSet(this, _text2, text);
    return this;
  }
  /**
   * Set the severity of the dialog
   * @param severity Severity of the dialog
   */
  setSeverity(severity) {
    __privateSet(this, _severity2, severity);
    return this;
  }
  /**
   * Set buttons from array
   * @param buttons Either an array of dialog buttons
   */
  setButtons(buttons) {
    if (__privateGet(this, _buttons2).length > 0) {
      console.warn("[@nextcloud/dialogs] Dialog buttons are already set - this overrides previous buttons.");
    }
    __privateSet(this, _buttons2, buttons);
    return this;
  }
  /**
   * Add a single button
   * @param button Button to add
   */
  addButton(button) {
    __privateGet(this, _buttons2).push(button);
    return this;
  }
  build() {
    return new Dialog(__privateGet(this, _name2), __privateGet(this, _text2), __privateGet(this, _buttons2), __privateGet(this, _severity2));
  }
}
_severity2 = /* @__PURE__ */ new WeakMap();
_text2 = /* @__PURE__ */ new WeakMap();
_name2 = /* @__PURE__ */ new WeakMap();
_buttons2 = /* @__PURE__ */ new WeakMap();
function getDialogBuilder(name) {
  return new DialogBuilder(name);
}
export {
  Dialog,
  DialogBuilder,
  DialogSeverity,
  FilePicker,
  FilePickerBuilder,
  FilePickerClosed,
  FilePickerType,
  h as TOAST_ARIA_LIVE_ASSERTIVE,
  f as TOAST_ARIA_LIVE_OFF,
  g as TOAST_ARIA_LIVE_POLITE,
  d as TOAST_DEFAULT_TIMEOUT,
  e as TOAST_PERMANENT_TIMEOUT,
  c as TOAST_UNDO_TIMEOUT,
  T as ToastAriaLive,
  b as ToastType,
  getDialogBuilder,
  getFilePickerBuilder,
  l as showError,
  k as showInfo,
  s as showMessage,
  i as showSuccess,
  m as showUndo,
  j as showWarning,
  spawnDialog
};
